import classNames from 'classnames';

import { Search } from 'lucide-react';
import React, { ChangeEvent, useCallback } from 'react';
import { theme } from 'styles/theme/theme';
import UDInput from 'ud-form/components/input/component';

export type TeamPlayersFilterValues = {
  name: string;
};

type TeamPlayersApplicationFiltersProps = {
  name?: string;
  inputPlaceholder?: string;
  onChange?: (values: TeamPlayersFilterValues) => void;
  className?: string;
};

function TeamPlayersApplicationFilters(props: TeamPlayersApplicationFiltersProps) {
  const { name = '', inputPlaceholder, onChange, className } = props;

  const handleOnChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      if (onChange) {
        onChange({
          name: event.target.value,
        });
      }
    },
    [onChange],
  );

  return (
    <div className={classNames('flex items-center justify-between', className)}>
      <div className="w-full">
        <UDInput
          value={name}
          placeholder={inputPlaceholder}
          iconProps={{
            position: 'icon-right',
            component: <Search size={16} color={theme.colors.SurfaceRomanSilver30} />,
          }}
          onChange={handleOnChange}
        />
      </div>
    </div>
  );
}

export default TeamPlayersApplicationFilters;
